import type { FC } from 'react';
import upperCase from 'lodash/upperCase';
import type { PromoTypeLegendItem } from '../../../types/calendar';

export interface PromoTypeLegendProps {
    items: PromoTypeLegendItem[];
}

const PromoTypeLegend: FC<PromoTypeLegendProps> = ({ items }) => {
    if (items.length === 0) return null;
    return (
        <div className="flex items-center justify-center bg-white px-[54px] py-2">
            <div className="flex flex-wrap items-center gap-x-6 gap-y-2">
                {items.map(({ type, color }) => (
                    <div key={type} className="flex items-center gap-x-2">
                        <span
                            className="inline-block h-1.5 w-[14px] rounded-[4px]"
                            style={{ backgroundColor: color }}
                        />
                        <span className="text-[10px] text-[#52525C]">{upperCase(type)}</span>
                    </div>
                ))}
            </div>
        </div>
    );
};

PromoTypeLegend.displayName = 'PromoTypeLegend';
export default PromoTypeLegend;
